import { DEFAULT_LOCALE } from "./module/constants";

import itAppTranslationMessages from "./translations/it.json";
import enAppTranslationMessages from "./translations/en.json";

const itTranslationMessages = {
  ...itAppTranslationMessages,
};

const enTranslationMessages = {
  ...enAppTranslationMessages,
};

export const appLocales = ["it", "en"];

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, itTranslationMessages)
      : {};
  return Object.keys(messages).reduce((formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  }, {});
};

export const translationMessages = {
  it: formatTranslationMessages("it", itTranslationMessages),
  en: formatTranslationMessages("en", enTranslationMessages),
};
